var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBCabinetPartnersAllocationIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 53,
    viewBox: "0 0 54 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_527_905)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 53,
    rx: 14,
    fill: "#270800"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_527_905)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.9999 11.8833C26.9999 11.5443 26.7249 11.2682 26.3862 11.2819C24.0848 11.3747 21.8316 11.9887 19.7977 13.0807C17.5832 14.2697 15.6976 15.9884 14.309 18.0835C12.9205 20.1785 12.0722 22.5847 11.8398 25.0874C11.6264 27.3861 11.9388 29.7005 12.7499 31.8562C12.8692 32.1735 13.2306 32.3191 13.5429 32.1871L17.32 30.5893C17.6323 30.4573 17.7764 30.0976 17.6639 29.7778C17.1915 28.4345 17.0138 27.0026 17.1458 25.58C17.2969 23.9532 17.8483 22.3892 18.7508 21.0274C19.6534 19.6656 20.8791 18.5485 22.3184 17.7757C23.5772 17.0998 24.9653 16.7057 26.3865 16.6174C26.7248 16.5964 26.9999 16.3236 26.9999 15.9846V11.8833Z",
    fill: "#FF3300"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_527_905)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.0847 34.7076C39.3651 34.8982 39.748 34.8259 39.9271 34.5381C41.256 32.4024 42.0367 29.9676 42.1951 27.4508C42.3663 24.7295 41.8036 22.0121 40.5657 19.5827C39.3278 17.1532 37.4602 15.1007 35.158 13.6397C33.0288 12.2884 30.6001 11.489 28.0911 11.3087C27.753 11.2844 27.4695 11.5517 27.4588 11.8905L27.33 15.9897C27.3194 16.3286 27.5858 16.6099 27.9233 16.6415C29.478 16.7872 30.9793 17.2991 32.3026 18.139C33.7991 19.0886 35.013 20.4227 35.8176 22.0019C36.6223 23.5811 36.9881 25.3473 36.8768 27.1162C36.7784 28.6804 36.31 30.1959 35.5141 31.5393C35.3413 31.831 35.4123 32.2118 35.6927 32.4024L39.0847 34.7076Z",
    fill: "#FF592E"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_527_905)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.6065 32.3401C13.2958 32.4756 13.1526 32.838 13.3005 33.143C14.3761 35.3611 15.9758 37.2879 17.9649 38.7544C20.1189 40.3425 22.6534 41.3348 25.313 41.6313C27.9727 41.9278 30.6635 41.5181 33.1143 40.4433C35.3776 39.4509 37.3623 37.9238 38.9 35.997C39.1115 35.7321 39.0516 35.347 38.7783 35.1464L35.4723 32.7194C35.1991 32.5188 34.8163 32.5791 34.5992 32.8394C33.6198 34.0135 32.3796 34.9469 30.9743 35.5631C29.3813 36.2617 27.6322 36.528 25.9035 36.3353C24.1747 36.1425 22.5273 35.4975 21.1272 34.4653C19.8921 33.5547 18.888 32.3711 18.1912 31.0102C18.0367 30.7084 17.6766 30.5653 17.3659 30.7008L13.6065 32.3401Z",
    fill: "#FFB62E"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_527_905",
    x: 0,
    y: 0,
    width: 54,
    height: 53,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.35 0 0 0 0 0.18 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_527_905"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_527_905",
    x: 11.7746,
    y: 11.2812,
    width: 15.2252,
    height: 20.9541,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.245523
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.75 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_527_905"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_527_905",
    x: 27.3297,
    y: 11.3076,
    width: 14.8954,
    height: 23.5059,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.245523
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.75 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_527_905"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_527_905",
    x: 13.2419,
    y: 30.6494,
    width: 25.7853,
    height: 11.0752,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.245523
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.75 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_527_905"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBCabinetPartnersAllocationIcon);
export default __webpack_public_path__ + "static/media/b_cabinet_partners_allocation_icon.d05538e07ac490ba7cf77fdda62bb995.svg";
export { ForwardRef as ReactComponent };